<div class="messages-container">
  <grid-toast *ngFor="let message of messagesService.messages"
              [iconName]="getIconaMessaggio(message)"
              [type]="message.type" [dismissable]="true" [timeout]="5000">
    <div slot="text">{{ message.text }}</div>
  </grid-toast>
</div>
